import { render, staticRenderFns } from "./ReportCard.vue?vue&type=template&id=23806bba&scoped=true&"
import script from "./ReportCard.vue?vue&type=script&lang=js&"
export * from "./ReportCard.vue?vue&type=script&lang=js&"
import style0 from "../UploadReportDialog.css?vue&type=style&index=0&id=23806bba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23806bba",
  null
  
)

export default component.exports